/**
 * 'Index'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import users from './users.store'
import events from './events.store'
import modal from './modal.store'
import profile from './profile.store'
import artist from './artists.store'
import eventArtist from './event-artist.store'
import categories from './categories.store'
/// //////////////////////////////////////////
import artistCategories from './configuration/artist-categories.store'
import eventCategories from './configuration/event-categories.store'
import presentations from './presentations.store'
import venues from './venues.store'
import zoneSelection from './zone-selection.store'

export default {
  users,
  events,
  modal,
  profile,
  artist,
  eventArtist,
  /// ////////
  categories,
  artistCategories,
  eventCategories,
  presentations,
  venues,
  zoneSelection
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js